module.exports = __webpack_public_path__ + "img/delete.3b522c7d.svg";